export enum UserRole {
  Owner = "Owner",
  Mentor = "Mentor",
  Viewer = "Viewer",
  Collaborator = "Collaborator"
}

export const PRIVILEGED_ROLES = [UserRole.Owner, UserRole.Mentor];

export const hasPrivilegedAccess = (userRole?: string): boolean => {
  if (!userRole) return false;
  return PRIVILEGED_ROLES.includes(userRole as UserRole);
};

export const isOwner = (userRole?: string): boolean => {
  return userRole === UserRole.Owner;
};
